var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmtp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9997 1H3.99967C2.52692 1 1.33301 2.19391 1.33301 3.66667V14.3333C1.33301 15.8061 2.52692 17 3.99967 17H19.9997C21.4724 17 22.6663 15.8061 22.6663 14.3333V3.66667C22.6663 2.19391 21.4724 1 19.9997 1Z",
    stroke: "#006600"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33301 5L10.8077 9.73733C11.1778 9.92229 11.5859 10.0186 11.9997 10.0186C12.4134 10.0186 12.8215 9.92229 13.1917 9.73733L22.6663 5",
    stroke: "#006600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmtp);
export default __webpack_public_path__ + "static/media/Smtp.5ea32f6b208fe8429fb5f552e5e2fd61.svg";
export { ForwardRef as ReactComponent };